import { getMessageInvalidLengthOfValue } from 'legacy/lut/helpers/getMessageInvalidLengthOfValue'

import { REGEX_COMPANY_NAME_FORBIDDEN_SYMBOLS } from 'clickNgo/configs/regex'

const DEFAULT_MIN_CHARS = 1

export const checkAsianCompanyName = (value: string) => {
  const valueToValidate = value.trim()

  if (valueToValidate.length < DEFAULT_MIN_CHARS) {
    return getMessageInvalidLengthOfValue({ min: DEFAULT_MIN_CHARS })
  }

  return REGEX_COMPANY_NAME_FORBIDDEN_SYMBOLS.test(valueToValidate)
    ? 'The company name has an incorrect symbols'
    : ''
}
